import { Dispatch, SetStateAction, useState } from 'react';

import { Button } from '../../../components/common/Button/Button';

import { Box, Flexed } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { Icon, IconWarningMark } from '../../../styles/Icons';
import { WithdrawStepsEnum } from './types';
import { P1, P2, P3 } from '../../../styles/FontStyles';
import { WithdrawWallet } from './WithdrawWallet';

interface Step5Props {
  setWithdrawStep: Dispatch<SetStateAction<WithdrawStepsEnum>>;
  walletAddress: string | undefined;
  packageId: number;
  walletAddressSign: string;
  code: string;
  code2Fa: string;
  isConnected: boolean;
  connectWallet: () => Promise<void>;
  setWalletAddressSign: Dispatch<SetStateAction<string>>;
}

export const Step5 = ({
  setWithdrawStep,
  walletAddress,
  connectWallet,
  isConnected,
  setWalletAddressSign
}: Step5Props) => {
  return (
    <>
      <Box gray>
        <Flexed column center>
          <Flexed>
            <Icon mb='12'>
              <IconWarningMark color={color.colors.primary900} size='52' />
            </Icon>
          </Flexed>

          <P1 bold center mb='20'>
            FINAL STEP: CONFIRM THE WITHDRAWAL OF YOUR HUB NFT
          </P1>
          <P2 bold center mb='20' color={color.colors.error500}>
            IMPORTANT: DOUBLE CHECK YOUR ADDRESS
          </P2>

          <WithdrawWallet
            walletAddress={walletAddress}
            connectWallet={connectWallet}
            isButtonVisible={false}
            isConnected={isConnected}
            setWalletAddressSign={setWalletAddressSign}
          />

          <P3 bold center mb='20' mt='20' color={color.colors.error500}>
            Your withdrawal request is not reversible and the decision you make
            can not be changed later!
          </P3>

          <Button
            w='350px'
            mr='12'
            onClick={() =>
              setWithdrawStep(WithdrawStepsEnum.SECURITY_VERIFICATION)
            }>
            MAKE HUB NFT WITHDRAWAL
          </Button>
        </Flexed>
      </Box>
    </>
  );
};
